import { useRef } from "react";
import { useHeadMotion } from "../../hooks";
import { REST_POSE, faceFeatures, featurePath } from "../../utils";
import type { HeadShape, TeammateFace } from "../../utils";

type TeammateLivelyEyesProps = {
  face: TeammateFace;
  head: HeadShape;
};

const TONES = { dark: "fill-gray-800", light: "fill-white" } as const;

export default function TeammateLivelyEyes({ face, head }: TeammateLivelyEyesProps) {
  const groupRef = useRef<SVGGElement>(null);
  const pathRefs = useRef<(SVGPathElement | null)[]>([]);
  const features = faceFeatures(face);

  useHeadMotion(groupRef, face.seed, (pose) => {
    features.forEach((feature, i) => pathRefs.current[i]?.setAttribute("d", featurePath(feature, head, pose)));
  });

  return (
    <g ref={groupRef}>
      {features.map((feature, i) => (
        <path
          key={i}
          ref={(el) => {
            pathRefs.current[i] = el;
          }}
          d={featurePath(feature, head, REST_POSE)}
          className={TONES[feature.tone]}
        />
      ))}
    </g>
  );
}
